const Loader = ()=>{
    return(
        <img src="/assests/loader.gif" className="loader"></img>
    )
}
export {Loader}